import { render, staticRenderFns } from "./ProjectsExpensesPayments.vue?vue&type=template&id=792b95f2"
import script from "./ProjectsExpensesPayments.vue?vue&type=script&lang=js"
export * from "./ProjectsExpensesPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports